// State-specific landing content for local municipal SEO. EN + HI.

export const regions = [
  {
    slug: "odisha",
    state: "Odisha",
    headline: "Landfill odour control & bio-mining across Odisha.",
    intro:
      "Odisha is where OED's municipal track record runs deepest. From the Bhubaneswar Municipal Corporation to Puri, we've helped urban local bodies eliminate odour, bio-mine legacy waste and recover land.",
    stats: [
      { v: "2.25L MT", l: "Legacy waste bio-mined at BMC" },
      { v: "600–700 MT", l: "Daily waste managed, zero odour" },
      { v: "Since 2019", l: "Active in the state" },
    ],
    cities: ["Bhubaneswar", "Puri", "Cuttack", "Rourkela"],
    deployments: ["bhubaneswar-bmc-biomining", "puri-legacy-landfill"],
    focus:
      "Municipal corporations and urban local bodies facing NGT pressure, bio-mining mandates and citizen odour complaints.",
    hi: {
      headline: "ओडिशा भर में लैंडफिल गंध नियंत्रण व बायो-माइनिंग।",
      intro:
        "ओडिशा में OED का नगरपालिका ट्रैक रिकॉर्ड सबसे गहरा है। भुवनेश्वर नगर निगम से पुरी तक, हमने शहरी निकायों को गंध हटाने, पुराने अपशिष्ट की बायो-माइनिंग व भूमि पुनर्प्राप्ति में मदद की है।",
      stats: ["BMC में बायो-माइन किया गया पुराना अपशिष्ट", "प्रतिदिन प्रबंधित अपशिष्ट, शून्य गंध", "राज्य में सक्रिय"],
      focus:
        "NGT दबाव, बायो-माइनिंग अधिदेश व नागरिक गंध शिकायतों का सामना कर रहे नगर निगम व शहरी निकाय।",
    },
  },
  {
    slug: "jharkhand",
    state: "Jharkhand",
    headline: "Years of continuous odour control across Jharkhand.",
    intro:
      "In Jharkhand, OED has sustained multi-year municipal engagements — from Godda Nagar Parishad to the Chas–Bokaro dumpsite — proving durability at scale, not just one-off demonstrations.",
    stats: [
      { v: "7 years", l: "Continuous service at Chas–Bokaro" },
      { v: "2–5 min", l: "Odour removal on application" },
      { v: "Since 2020", l: "At Godda Nagar Parishad" },
    ],
    cities: ["Chas", "Bokaro", "Godda", "Garhwa"],
    deployments: ["godda-nagar-parishad", "chas-bokaro-dumpsite"],
    focus:
      "Municipal corporations and Nagar Parishads managing legacy dumpsites and recurring odour complaints.",
    hi: {
      headline: "झारखंड भर में वर्षों का निरंतर गंध नियंत्रण।",
      intro:
        "झारखंड में OED ने कई-वर्षीय नगरपालिका साझेदारियाँ बनाए रखी हैं — गोड्डा नगर परिषद से चास–बोकारो डंपसाइट तक — जो केवल एकबारगी प्रदर्शन नहीं, बल्कि बड़े पैमाने पर टिकाऊपन साबित करती हैं।",
      stats: ["चास–बोकारो में निरंतर सेवा", "आवेदन पर गंध निवारण", "गोड्डा नगर परिषद में"],
      focus:
        "पुराने डंपसाइट व बार-बार आने वाली गंध शिकायतों का प्रबंधन कर रहे नगर निगम व नगर परिषद।",
    },
  },
  {
    slug: "maharashtra",
    state: "Maharashtra",
    headline: "Industrial-grade RDF odour control in Maharashtra.",
    intro:
      "In Maharashtra, OED supports both municipal remediation and heavy industry — including RDF odour control at UltraTech Cement's Manikgarh plant, neutralising methane, hydrogen sulphide and ammonia.",
    stats: [
      { v: "22,000 L", l: "Bio-culture supplied to UltraTech" },
      { v: "1–2 min", l: "Smell neutralised on application" },
      { v: "CH₄·H₂S·NH₃", l: "Toxic gases neutralised" },
    ],
    cities: ["Chandrapur", "Nagpur", "Pune", "Mumbai"],
    deployments: ["ultratech-cement-rdf"],
    focus:
      "Cement plants and RDF handlers, plus municipal corporations addressing legacy landfill odour.",
    hi: {
      headline: "महाराष्ट्र में औद्योगिक-स्तर का RDF गंध नियंत्रण।",
      intro:
        "महाराष्ट्र में OED नगरपालिका उपचार व भारी उद्योग दोनों का समर्थन करता है — UltraTech Cement के मानिकगढ़ संयंत्र में RDF गंध नियंत्रण सहित, जो मीथेन, हाइड्रोजन सल्फाइड व अमोनिया निष्क्रिय करता है।",
      stats: ["UltraTech को आपूर्ति बायो-कल्चर", "आवेदन पर गंध निष्क्रिय", "निष्क्रिय विषैली गैसें"],
      focus:
        "सीमेंट संयंत्र व RDF हैंडलर, साथ ही पुरानी लैंडफिल गंध का समाधान कर रहे नगर निगम।",
    },
  },
  {
    slug: "west-bengal",
    state: "West Bengal",
    headline: "Biological waste remediation for West Bengal.",
    intro:
      "West Bengal is a priority state in our Eastern India expansion. OED offers urban local bodies a low-risk, pilot-led path to odour control, faster decomposition and land recovery.",
    stats: [
      { v: "50–60%", l: "of urban waste is organic" },
      { v: "Pilot-led", l: "Low-risk entry for ULBs" },
      { v: "Eastern India", l: "Core expansion region" },
    ],
    cities: ["Kolkata", "Howrah", "Siliguri", "Durgapur"],
    deployments: [],
    focus:
      "Municipal corporations and urban local bodies seeking measurable odour reduction before full deployment.",
    hi: {
      headline: "पश्चिम बंगाल के लिए जैविक अपशिष्ट उपचार।",
      intro:
        "पश्चिम बंगाल हमारे पूर्वी भारत विस्तार में एक प्राथमिकता राज्य है। OED शहरी निकायों को गंध नियंत्रण, तेज़ अपघटन व भूमि पुनर्प्राप्ति हेतु एक कम-जोखिम, पायलट-आधारित मार्ग प्रदान करता है।",
      stats: ["शहरी अपशिष्ट जैविक है", "ULB हेतु कम-जोखिम प्रवेश", "मुख्य विस्तार क्षेत्र"],
      focus:
        "पूर्ण तैनाती से पहले मापने योग्य गंध कमी चाहने वाले नगर निगम व शहरी निकाय।",
    },
  },
  {
    slug: "assam",
    state: "Assam",
    headline: "Odour control & land recovery for Assam.",
    intro:
      "Assam anchors our North-East presence. OED's indigenous microbial platform is suited to the region's high-organic waste streams, delivering rapid odour relief and accelerated decomposition.",
    stats: [
      { v: "Indigenous", l: "Microbial ecosystem" },
      { v: "100%", l: "Odour control within a week" },
      { v: "Pilot-led", l: "Low-risk engagement" },
    ],
    cities: ["Guwahati", "Dibrugarh", "Silchar", "Jorhat"],
    deployments: [],
    focus:
      "Municipal bodies and industrial organic-waste generators managing odour and slow decomposition.",
    hi: {
      headline: "असम के लिए गंध नियंत्रण व भूमि पुनर्प्राप्ति।",
      intro:
        "असम हमारी पूर्वोत्तर उपस्थिति का आधार है। OED का स्वदेशी सूक्ष्मजीवी मंच क्षेत्र की उच्च-जैविक अपशिष्ट धाराओं के अनुकूल है, जो त्वरित गंध राहत व तेज़ अपघटन देता है।",
      stats: ["सूक्ष्मजीवी परितंत्र", "एक सप्ताह में गंध नियंत्रण", "कम-जोखिम साझेदारी"],
      focus:
        "गंध व धीमे अपघटन का प्रबंधन कर रहे नगरपालिका निकाय व औद्योगिक जैविक-अपशिष्ट उत्पादक।",
    },
  },
];

export const getRegion = (slug) => regions.find((r) => r.slug === slug);
